import { ServiceStatusDto } from './../../model/service-status-dto';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpclientService } from '../../services/httpclient.service';

@Component({
  selector: 'app-service-status',
  templateUrl: './service-status.component.html',
  styleUrls: ['./service-status.component.css']
})
export class ServiceStatusComponent implements OnInit {
  loading  : boolean;
  modalPopup : boolean =false;
  modalPopup1 : boolean = false;
  isStatus : boolean;
  serviceStatusList: ServiceStatusDto[];
  constructor(private httpclientService : HttpclientService,private router : Router) { }

  ngOnInit() {
    this.getExtentiveLogging();
  }
 
  pressingOK(){
    this.modalPopup=false;
    this.router.navigate(['dashboard']);
  }
  pressingCancel(){
    this.modalPopup=false;
  }
  pressingOK1(){
    // this.saving="";
    this.modalPopup1=false;
  }
  checkValue(values:any){
    console.log(values.currentTarget.checked);
    this.isStatus=values.currentTarget.checked;
    
 }

 getExtentiveLogging() {
  // this.loading = true;
  this.httpclientService.getServiceStatusList(sessionStorage.getItem('globelUserId')).subscribe(
  data => {
    this.serviceStatusList = data;
    // this.loading = false;
  }
);
}
}
